import React from "react";
import { PlayCircleOutlined } from "@ant-design/icons";
import "./VideoLessonSubtopics.css";

function VideoLessonSubtopics({ subtopics, onSelect, selectedVideo }) {
  return (
    <div className="lesson-subtopics-container">
      <span className="subtopics-header">{subtopics.length} Lesson Subtopics</span>
      <ul className="subtopics-list">
        {subtopics.map((subtopic, index) => (
          <li
            key={index}
            className={`subtopic-item ${selectedVideo?.id === subtopic.id ? "selected" : ""}`}
            onClick={() => onSelect && onSelect(subtopic)}
          >
            <div>
            <PlayCircleOutlined className="play-icon" />
            <span className="subtopic-title">{subtopic.title}</span>
            </div>
            <span className="subtopic-time">{formatTime(subtopic.duration)}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}

function formatTime(timeInSeconds) {
  const minutes = Math.floor(timeInSeconds / 60);
  const seconds = Math.floor(timeInSeconds % 60);
  return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
}

export default VideoLessonSubtopics;
